<template>
	<div :class="rctype == 1?'':'gttcard'" style="margin-bottom: 24px;">
		<p v-if="rctype == 0" class="gttcard-tt">{{ $t('terminal.broadcast_record') }}</p>
		<div class="gttcard-in">
			<el-row :gutter="20">
				<el-col :span="3">
					<el-button @click="output" size="small" type="primary">{{ $t('terminal.export_records') }}</el-button>
				</el-col>
				<el-col :span="5">
					<div class="glineflex" v-if="ctype == 0">
						<label class="glinelb">{{ $t('terminal.serial_number') }}：</label>
						<el-input @keyup.enter.native="srcList" v-model="order" size="small" :placeholder="$t('terminal.serial_number')">
						</el-input>
					</div>
					<div class="glineflex" v-else>
						<label class="glinelb">{{ $t('terminal.branch_store') }}：</label>
						<Bstore :config="bconfig"></Bstore>
					</div>
				</el-col>
				<el-col :span="6">
					<div class="glineflex">
						<label class="glinelb">{{ $t('terminal.broadcast_state') }}：</label>
						<el-select size="small" v-model="pstatus" clearable style="width: 100%;" :placeholder="$t('app_select')"
							@change="srcList">
							<el-option v-for="(item,index) in $playSts" :key="index" :label="item.lb" :value="item.vl">
							</el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :span="10">
					<div class="glineflex">
						<label class="glinelb">{{ $t('terminal.date_filter') }}：</label>
						<el-date-picker style="width: 100%;" size="small" @change="srcList" v-model="pkdate"
							value-format="yyyy-MM-dd" type="daterange" range-separator="~" :start-placeholder="$t('app_start_time')"
							:end-placeholder="$t('app_end_time')"></el-date-picker>
					</div>
				</el-col>
			</el-row>
			<el-table class="gtbtop" tooltip-effect="dark" :data="tableData" style="width: 100%">
				<el-table-column v-if="ctype == 1" prop="deviceId" :label="$t('terminal.device_no')" width></el-table-column>
				<el-table-column prop="amount" :label="$t('terminal.app_amount')" width :formatter="symbol"></el-table-column>
				<el-table-column prop="status" :label="$t('terminal.broadcast_state')" :formatter="setPS" width></el-table-column>
				<el-table-column prop="template" :label="$t('terminal.broadcast_template')"></el-table-column>
				<el-table-column v-if="ctype == 1" prop="referenceid" :label="$t('terminal.serial_number')" width></el-table-column>
				<el-table-column v-else prop="traceid" :label="$t('terminal.serial_number')" width></el-table-column>
				<!-- <el-table-column
          prop="terminalStatus"
          label="交易时间"        
          width="">
          <template slot-scope="scope">
            <div v-if='scope.row.terminalStatus == 0' class='eqbs-ball-gray'></div>
            <div v-else class='eqbs-ball-green'></div>
            &nbsp;<label>{{$eqBindSt[scope.row.terminalStatus + '']}}</label>
          </template>
        </el-table-column>-->
				<el-table-column prop="requesttime" :label="$t('terminal.broadcast_time')" width></el-table-column>
			</el-table>
			<Pages class="gpages" :cpage="page" :ctotal="total" :config="pconfig"></Pages>
		</div>
	</div>
</template>

<script>
	import Pages from "@/components/Pages.vue";
	import Bstore from "@/components/Bstore.vue";
	export default {
		data() {
			return {
				order: "",
				ptype: "",
				pstatus: "",
				total: 0,
				page: 1,
				pconfig: "",
				tableData: [],
				pkdate: [],
				mcid: "",
				dvid: "",
				stid: "",
				ctype: "0", //// 0 equip 1 bcstore
				bconfig: {}
			};
		},
		components: {
			Pages,
			Bstore
		},
		props: ["ctotal", "config"],
		computed: {
			rctype() {
				return this.ctype;
			}
		},
		watch: {
			config(cf) {
				var _this = this;
				this.dvid = cf.dvid ? cf.dvid : "";
				this.mcid = cf.mcid ? cf.mcid : "";
				// this.stid = cf.storeid?cf.storeid:''
				this.ctype = cf.ctype;
				this.pconfig = {
					callback: page => {
						///
						_this.page = page;
						_this.getList();
					}
				};
				this.bconfig = {
					size: "small",
					mcid: this.mcid,
					callback: vl => {
						_this.stid = vl ? vl : "";
						_this.getList();
					}
				};
				this.getList();
			}
		},
		methods: {
			setPS(row) {
				var vl = this.$playSt[row.status];
				return vl ? vl : row.status;
				// return row.status
			},
			output() {
				var deviceid = this.dvid;
				var merchantId = this.mcid;

				var stime = "";
				var etime = "";
				if (this.pkdate) {
					stime = this.pkdate.length > 0 ? this.pkdate[0] : "";
					etime = this.pkdate.length > 1 ? this.pkdate[1] : "";
				}
				if (this.ctype == 0) {
					this.$outputRcRecord(
						deviceid,
						this.order,
						this.ptype,
						this.pstatus,
						merchantId,
						stime,
						etime
					);
				} else {
					this.$outputBCSRecord(this.stid, this.mcid, this.pstatus, stime, etime);
				}
			},
			srcList() {
				this.page = 1;
				this.getList();
			},
			getList() {
				this.loading = true;
				var deviceid = this.dvid;
				var merchantId = this.mcid;
				var stime = "";
				var etime = "";
				if (this.pkdate) {
					stime = this.pkdate.length > 0 ? this.pkdate[0] : "";
					etime = this.pkdate.length > 1 ? this.pkdate[1] : "";
				}
				if (this.ctype == 0) {
					this.$equipLogpay(
						this.page,
						this.$gRow,
						deviceid,
						this.order,
						this.ptype,
						this.pstatus,
						merchantId,
						stime,
						etime,
						res => {
							this.loading = false;
							if (res.status == 200) {
								//console.log('receip: '+ JSON.stringify(res.data))
								this.total = res.total;
								this.tableData = res.data;
							} else {
								this.$message.error(res.message);
							}
						},
						""
					);
				} else {
					this.$bcstPlayRc(
						this.page,
						this.$gRow,
						this.stid,
						merchantId,
						this.pstatus,
						stime,
						etime,
						res => {
							this.loading = false;
							if (res.status == 200) {
								this.total = res.total;
								this.tableData = res.data;
							} else {
								this.$message.error(res.message);
							}
						},
						""
					);
				}
			},
			symbol(row, column) {
				return "¥" + row.amount;
			}
		},
		mounted() {

			var _this = this;
			this.pconfig = {
				callback: page => {
					///
					_this.page = page;
					_this.getList();
				}
			};
			// this.getList()
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
